export default "__VITE_ASSET__CsBbsWXl__"